import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/member",
  name: "member",
  redirect: "/member/index",
  component: RouteView,
  meta: {
    title: "会员管理",
    showNavBar: false,
  },
  children: [
    {
      path: "/member/index",
      name: "memberIndex",
      component: () =>
        import(/* webpackChunkName: "mamber" */ "@/views/member/Index.vue"),
      meta: {
        title: "会员管理",
        showNavBar: true,
      },
    },
    {
      path: "/member/list",
      name: "memberList",
      component: () =>
        import(/* webpackChunkName: "mamber" */ "@/views/member/List.vue"),
      meta: {
        title: "会员列表",
        showNavBar: false,
      },
    },
    {
      path: "/member/info",
      name: "memberInfo",
      component: () =>
        import(/* webpackChunkName: "mamber" */ "@/views/member/Info.vue"),
      meta: {
        title: "会员详情",
        showNavBar: false,
      },
    },
    {
      path: "/member/add",
      name: "memberAdd",
      component: () =>
        import(/* webpackChunkName: "mamber" */ "@/views/member/Add.vue"),
      meta: {
        title: "会员编辑",
        showNavBar: false,
      },
    },
    {
      path: "/member/type",
      name: "memberType",
      component: () =>
        import(/* webpackChunkName: "mamber" */ "@/views/member/memberType/List.vue"),
      meta: {
        title: "会员类型",
        showNavBar: false,
      },
    },
    {
      path: "/member/type-info",
      name: "memberTypeInfo",
      component: () =>
        import(/* webpackChunkName: "mamber" */ "@/views/member/memberType/Info.vue"),
      meta: {
        title: "会员类型详情",
        showNavBar: false,
      },
    },
    {
      path: "/member/recharge",
      name: "memberRecharge",
      component: () =>
        import(/* webpackChunkName: "mamber" */ "@/views/member/Recharge.vue"),
      meta: {
        title: "会员充值",
        showNavBar: false,
      },
    },
    {
      path: "/member/consume",
      name: "memberConsume",
      component: () =>
        import(/* webpackChunkName: "mamber" */ "@/views/member/Consume.vue"),
      meta: {
        title: "会员消费",
        showNavBar: false,
      },
    },
    {
      path: "/member/account-record",
      name: "memberAccountRecord",
      component: () =>
        import(/* webpackChunkName: "mamber" */ "@/views/member/AccountRecord.vue"),
      meta: {
        title: "会员消费记录",
        showNavBar: false,
      },
    },
    {
      path: "/member/modifyPass",
      name: "memberModifyPass",
      component: () =>
        import(/* webpackChunkName: "mamber" */ "@/views/member/modifyPass.vue"),
      meta: {
        title: "会员密码修改",
        showNavBar: false,
      },
    },
  ],
};
